import {
    parsePhoneNumberFromString,
    CountryCode,
    isPossibleNumber,
    parseNumber,
    ParsedNumber,
} from "libphonenumber-js";
import { ValidationRules } from "common.ui/Validations/validationRules";

export const required = (value) => (value ? undefined : "Required");

export const email = (value) =>
    value && !ValidationRules.isEmailAddressValid(value) ? "Invalid email address" : undefined;

const maxLength = (max) => (value) => (value && value.length > max ? `Must be ${max} characters or less` : undefined);

const minLength = (min) => (value) => (value && value.length < min ? `Must be ${min} characters or more` : undefined);

export const minLength8 = minLength(8);

export const minLength6 = minLength(6);
export const maxLength30 = maxLength(30);

const fixedLength = (length) => (value) =>
    value && value.length !== length ? `Must be ${length} characters` : undefined;

export const fixedLength6 = fixedLength(6);

export function validatePhonePrefix(value: string, countryCode: CountryCode) {
    const phoneNumber = parsePhoneNumberFromString(value, countryCode);

    if (!phoneNumber || (phoneNumber.country && phoneNumber.country !== countryCode)) {
        return `Not valid ${countryCode} number`;
    }
    return undefined;
}

export function validatePhoneFormat(value: string, countryCode: CountryCode) {
    if (countryCode === "AU" && isUnusualAuNumber(value)) {
        return undefined;
    }

    // Check Domestic number as well as International number
    let parsed = parseNumber(value, countryCode) as ParsedNumber;
    if (isPossibleNumber(parsed)) return undefined;

    return `Not a valid number`;
}

function isUnusualAuNumber(value: string) {
    return (value.startsWith("05") && value.length === 10) || (value.startsWith("+615") && value.length === 12);
}
